import { render, staticRenderFns } from "./CPopup.vue?vue&type=template&id=16ddef07&scoped=true&"
import script from "./CPopup.vue?vue&type=script&lang=js&"
export * from "./CPopup.vue?vue&type=script&lang=js&"
import style0 from "./CPopup.vue?vue&type=style&index=0&id=16ddef07&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ddef07",
  null
  
)

export default component.exports